<div (click)="onClicked()" class="p-2 hover:bg-ponder-linkhover hover:bg-opacity-15 hover:cursor-pointer" [ngClass]="{ 'rounded-b-md' : isLast, 'border-b-[1px]' : !isLast, 'bg-ponder-linkhover bg-opacity-20' : isSelected }">
    {{ label }}
</div>